module.exports = __webpack_public_path__ + "static/phenomic-logo-d23af4ff472862bccf69511145ec0e4f.png";